import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/index'
import routes from './routes'

Vue.use(VueRouter)

const rules = {
  guest: { fail: '', check: () => (!store.getters['auth/me']) },
  auth: {
    fail: 'login',
    check: function () {
      return (store.getters['auth/token'] && store.getters['auth/check'])
    }
  },
  // PASSWORDCHANGE: {
  //   fail: 'login',
  //   check: function () {
  //     // let myProfile = store.getters['auth/myProfile']
  //     // return (store.getters['auth/token'] && store.getters['auth/check']  && myProfile?.must_change_password);
  //   }
  // },
  ADMINISTRATOR: {
    fail: 'schedule',
    check: function () {
      let myProfile = store.getters['auth/myProfile']
      if (myProfile?.must_change_password) return false;
      // console.log('admin')
      return (myProfile?.role == "ADMINISTRATOR");
    }
  },
  MANAGER: {
    fail: 'schedule',
    check: function () {
      let myProfile=store.getters['auth/myProfile']
      if (myProfile?.must_change_password) return false;
      // console.log('MANAGER')
      return (myProfile?.role == "MANAGER" || myProfile?.role == "ADMINISTRATOR");
    }
  },
  FOREMAN: {
    fail: 'schedule',
    check: function () {
      let myProfile = store.getters['auth/myProfile']
      if (myProfile?.must_change_password) return false;
      // console.log('STAFF')
      return (myProfile?.role == "MANAGER" || myProfile?.role == "ADMINISTRATOR" || myProfile?.role == "FOREMAN");
    }
  },
  STAFF: {
    fail: 'login',
    check: function () {
      let myProfile = store.getters['auth/myProfile']
      if (myProfile?.must_change_password) return false;
      // console.log('STAFF')
      return (myProfile?.role == "STAFF" || myProfile?.role == "MANAGER" || myProfile?.role == "ADMINISTRATOR" || myProfile?.role == "FOREMAN");
    }
  },
}

const router = new VueRouter({
  mode: 'history',
  routes, rules
})

router.beforeEach(async (to, from, next) => {
  if (store.getters['auth/token'] && !store.getters['auth/check']) {
    try {
      await store.dispatch('auth/setUser')
      await store.dispatch('auth/setMyProfile')
    } catch (e) {
      // dosomething
    }
  }

  let route = reroute(to)
  if (route) {
    next(route)
  }
  else {
    next()
  }
})



function reroute(to) {
  let failRoute = false,
  checkResult = false
  // console.log(to.meta.rules)
  to.meta.rules && to.meta.rules.forEach(rule => {
    let check = false
    if (Array.isArray(rule)) {
      let checks = []
      for (let i in rule) {
        checks[i] = rules[rule[i]].check()
        check = check || checks[i]
      }
      if (!check && !failRoute) {
        failRoute = rules[rule[checks.indexOf(false)]].fail
      }
    }
    else {
      check = rules[rule].check()
      if (!check && !failRoute) {
        failRoute = rules[rule].fail
      }
    }

    checkResult = checkResult && check
  })

  if (!checkResult && failRoute) {
    return { name: failRoute }
  }

  return false
}

export default router
